import React, { useEffect, useState } from 'react';
import { BehaviorSubject } from 'rxjs';
import { Loading } from 'components/block/loading';

export const loadingSubject = new BehaviorSubject<number[]>([]);

export function LoadingContainer() {
  const [loadings, setLoadings] = useState<number[]>([]);

  useEffect(() => {
    loadingSubject.subscribe((loadings) => {
      setLoadings(loadings);
    });
  }, []);

  return <div className='loading-container'>{loadings && !!loadings.length && <Loading />}</div>;
}
